import { render, staticRenderFns } from "./BaseArcticle.vue?vue&type=template&id=8e54572e&scoped=true&"
import script from "./BaseArcticle.vue?vue&type=script&lang=js&"
export * from "./BaseArcticle.vue?vue&type=script&lang=js&"
import style0 from "./BaseArcticle.vue?vue&type=style&index=0&id=8e54572e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e54572e",
  null
  
)

export default component.exports